module.exports = __webpack_public_path__ + "img/edit-icon.14065011.svg";